<template>
  <div>
    <usage-tabs />
    <usage-room />
  </div>
</template>

<script>
import Room from "@/components/dashboard/operation-index/interspace/usage/room.vue";
import Tabs from "@/components/dashboard/operation-index/interspace/usage/tabs";
export default {
  components: {
    [Room.name]: Room,
    [Tabs.name]: Tabs
  },
  setup() {}
};
</script>
